import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ViewMode } from '@common/models/view-mode';
import { fromEvent, merge, Subject, takeUntil } from 'rxjs';
import { QueryService } from './query.service';

@Injectable()
export class WindowFocusService implements OnDestroy {
    private readonly destroy$ = new Subject<void>();
    private readonly focus$ = merge(fromEvent(window, 'focus'), fromEvent(document, 'visibilitychange'));

    constructor(
        private zone: NgZone,
        private queryService: QueryService,
        private router: Router
    ) {
        this.zone.runOutsideAngular(() => {
            this.focus$.pipe(takeUntil(this.destroy$)).subscribe(() => {
                const isViewMode = this.router.url.split('/')?.filter((path) => path === ViewMode.view).length > 0;
                if (!isViewMode || document.visibilityState !== 'visible' || !document.hasFocus()) return;
                for (const queryKey of this.queryService.queriesToRefetchOnFocus)
                    this.queryService.queryClient.invalidateQueries({ queryKey: [queryKey], refetchType: 'active' });
            });
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
